import type { AwsLoginInstaller } from "../../types";
import { federatedLoginInstaller } from "./federated";
import { accountReference, midcIdentityReference } from "./listers";
import { midcPrerequisiteMessages } from "./merged-idc";

export const loginInstaller: AwsLoginInstaller = {
  options: {
    idc: { items: { parent: { optionProvider: accountReference } } },
    "merged-idc": {
      prerequisiteMessages: midcPrerequisiteMessages,
      items: { parent: { optionProvider: midcIdentityReference } },
    },
    federated: federatedLoginInstaller,
  },
};
